__turbopack_context__.v({
  "inspiration": "DestinationArticleTag-module__tyLWzq__inspiration",
  "medium": "DestinationArticleTag-module__tyLWzq__medium",
  "practicalInformation": "DestinationArticleTag-module__tyLWzq__practicalInformation",
  "small": "DestinationArticleTag-module__tyLWzq__small",
  "tag": "DestinationArticleTag-module__tyLWzq__tag",
});
